import { render, staticRenderFns } from "./LiveClassAttendance.vue?vue&type=template&id=56d7a5de&scoped=true"
import script from "./LiveClassAttendance.vue?vue&type=script&lang=js"
export * from "./LiveClassAttendance.vue?vue&type=script&lang=js"
import style0 from "./LiveClassAttendance.vue?vue&type=style&index=0&id=56d7a5de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d7a5de",
  null
  
)

export default component.exports